(function () {
    'use strict';

    function workflowController($scope, $rootScope, $timeout, $state, $uibModal,
        notifyService, workflowData, functionsConfigurationData, sessionData,
        workflowStateService, mailRequestDataService, signalrService, toastr, $pbService) {
        var vm = this;
        vm.sessionData = sessionData;
        vm.workflowId = workflowData.Id.split('/')[1];
        vm.workflowData = workflowData;
        vm.canSeeWholeWorkflow = !workflowData.Phases
            .filter(function (phase) {
                return !phase.IsRemoved;
            }).some(function (phase) {
                return !phase.Access.View;
            });
        vm.workflowTypeIdentifier = vm.workflowData.WorkflowTypeIdentifier || 'Project';
        vm.stateParams = {};
        vm.tabs = {
            'workflow.roadmap': {
                header: 'Roadmap',
                active: false,
                additionalStates: []
            },
            'workflow.navigator': {
                header: vm.workflowTypeIdentifier + ' Workflow',
                active: true,
                additionalStates: ['workflow.navigator.phase', 'workflow.sharingsearch', 'workflow.sharingsearch.phase']
            },
            'workflow.documents': {
                header: 'Documents',
                active: false,
                additionalStates: []
            },
            'workflow.internalfiles': {
                header: vm.workflowData.InternalContent.Title,
                active: false,
                additionalStates: ['workflow.sharingsearch.internalfiles']
            },
            'workflow.notes': {
                header: 'Notes',
                active: false,
                additionalStates: []
            },
            'workflow.sharing': {
                header: 'Partners',
                active: false,
                additionalStates: []
            },
            'workflow.summary': {
                header: vm.workflowTypeIdentifier + ' Summary',
                active: false,
                additionalStates: []
            }
        };

        var workflowHeaderPopoverClass = 'workflow-header-popover';
        vm.popoverConfig = {
            id: 'workflowHeaderPopover',
            class: 'comments-menu-popover ' + workflowHeaderPopoverClass,
            placement: 'bottom',
            template: 'workflow/templates/commentsMenuPopover.html',
            outsideSelector: 'div.' + workflowHeaderPopoverClass,
            outsideIgnoreSelector: 'button.' + workflowHeaderPopoverClass
        }

        vm.progressCircleOptions = {
            color: '#fff',
            trailColor: 'rgba(255, 255, 255, .2)',
            duration: 1400,
            strokeWidth: 3,
            trailWidth: 3,
            easing: 'easeInOut',
            text: {
                autoStyleContainer: false,
                style: {
                    // Text color.
                    // Default: same as stroke color (options.color)
                    color: '#fff',
                    position: 'absolute',
                    left: '50%',
                    top: '39px',
                    padding: 0,
                    margin: 0,
                    // You can specify styles which will be browser prefixed
                    transform: {
                        prefix: true,
                        value: 'translate(-50%, -50%)'
                    },
                    fontSize: '1.1em',
                }
            }
        };

        vm.progressPercentageComplete = 0;
        vm.saveLocalTitle = function () {};
        vm.titleContext = '';
        vm.editTitleData = {
            Title: '',
            OriginalTitle: ''
        };
        vm.currentStateName = 'workflow.roadmap';
        // vm.showProgress = true;

        $scope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            vm.stateParams = toParams;
            vm.currentStateName = toState.name;
            vm.titleBarButtons = [];

            if (vm.stateParams.phaseIndex) {
                vm.phaseIndex = parseInt(vm.stateParams.phaseIndex, 10);
            }
            vm.changeTab(toState.name);
            $('html,body').scrollTop(0);

            if ($rootScope.workflowReorderMode && $rootScope.workflowReorderModeToast) {
                toastr.clear($rootScope.workflowReorderModeToast);
            }

            $rootScope.workflowReorderMode = false;

            switch (toState.name) {
                case ('workflow.roadmap'):
                    vm.isCommentsPopoverVisible = false;
                    vm.popoverContext = {
                        Path: "",
                        ProjectUnderwritingNotes: vm.workflowData.ProjectUnderwritingNotes
                    };
                    vm.workflowTitleMode = vm.workflowData.Access.Edit ? 'display': 'readonly';
                    vm.progressPercentageComplete = vm.workflowData.PercentageComplete / 100;
                    vm.editTitleData.Title = vm.workflowData.Name;
                    vm.editTitleData.OriginalTitle = vm.workflowData.Name;
                    vm.titleContext = vm.workflowData.WorkflowTypeIdentifier || 'project';
                    vm.saveLocalTitle = function () {
                        vm.workflowData.Name = vm.editTitleData.Title;
                    }
                    vm.siblingNames = [];
                    vm.workflowViewMode = 'roadmap';
                    vm.showTitleBarButton = vm.workflowData.Access.Edit;
                    var deleteProjectButton = {
                        text: 'Delete ' + vm.workflowTypeIdentifier,
                        click: function () {
                            var modalInstance = $uibModal.open({
                                templateUrl: 'workflow/templates/deleteWorkflowModal.html',
                                controller: 'deleteWorkflowModalController',
                                windowClass: 'workflow-delete-modal',
                                resolve: {
                                    workflowId: function() {
                                        return vm.workflowData.Id;
                                    },
                                    workflowTypeIdentifier: function () {
                                        return vm.workflowTypeIdentifier;
                                    }
                                }
                            });

                            return modalInstance.result.then(function(wasDeleted) {
                                if (wasDeleted) {
                                    $state.go('dashboard');
                                }
                            });
                        }
                    };
                    var addPhaseButton = {
                        text: 'Add Phase',
                        click: function () {
                            var titleAndPrompt = 'New Phase';
                            var newPhaseCount = vm.workflowData.Phases.filter(function (phase) {
                                return phase.Title.startsWith('New Phase');
                            }).length;
                            if (newPhaseCount > 0) {
                                titleAndPrompt = titleAndPrompt + ' (' + newPhaseCount + ')';
                            }
                            workflowStateService.addPhase(titleAndPrompt);
                        }
                    }
                    vm.titleBarButtons = [];
                    if ((vm.sessionData.EntityId == vm.workflowData.EntityId) ||
                        vm.sessionData.IsAdminEntity) {
                        vm.titleBarButtons.push(deleteProjectButton);
                    }

                    if (vm.workflowData.Access.Edit)
                    {
                        vm.titleBarButtons.push(addPhaseButton);
                    }
                    break;
                case ('workflow.navigator.phase'):
                    vm.isCommentsPopoverVisible = vm.workflowData.Phases[vm.phaseIndex -1].Access.Notes;
                    //vm.showProgress = vm.workflowData.Phases[vm.phaseIndex -1].Status !== 'Skipped';
                    vm.popoverContext = {
                        Path: vm.workflowData.Phases[vm.phaseIndex -1].Path,
                        ProjectUnderwritingNotes: vm.workflowData.Phases[vm.phaseIndex -1].ProjectUnderwritingNotes
                    };
                    vm.workflowTitleMode = vm.workflowData.Phases[vm.phaseIndex -1].Access.Edit ? 'display': 'readonly';
                    vm.progressPercentageComplete = vm.workflowData.Phases[vm.phaseIndex - 1].PercentageComplete / 100;
                    vm.editTitleData.Title = vm.workflowData.Phases[vm.phaseIndex - 1].Prompt;
                    vm.editTitleData.OriginalTitle = vm.workflowData.Phases[vm.phaseIndex - 1].Prompt;
                    vm.titleContext = 'phase';
                    vm.saveLocalTitle = function () {
                        vm.workflowData.Phases[vm.phaseIndex - 1].Prompt = vm.editTitleData.Title;
                    }
                    vm.siblingNames = vm.workflowData.Phases.filter(function (phase) {
                        return !phase.IsRemoved;
                    }).map(function (p) { return p.Title; });
                    vm.workflowViewMode = 'phase';
                    vm.showTitleBarButton = vm.workflowData.Phases[vm.phaseIndex -1].Access.Edit;
                    vm.titleBarButtons = [
                        {
                            text: 'Delete Phase',
                            click: function () {
                                var modalInstance = $uibModal.open({
                                    templateUrl: 'workflow/templates/deletePhaseModal.html',
                                    controller: 'deletePhaseModalController',
                                    windowClass: 'workflow-delete-modal'
                                });

                                return modalInstance.result.then(function(wasDeleted) {
                                    if (wasDeleted) {
                                        vm.workflowData.Phases[vm.phaseIndex -1].IsRemoved = true;
                                        workflowStateService.resolveNotesForPath(vm.workflowData.Phases[vm.phaseIndex -1].Path);
                                        workflowStateService.update(vm.workflowData);
                                        notifyService.notify('You have removed this phase');
                                        $state.go('workflow.roadmap', {  workflowId: vm.workflowData.Id.split('/')[1] });
                                    }
                                });
                            }
                        },
                        {
                            text: vm.workflowData.Phases[vm.phaseIndex -1].Status === 'Skipped' ? 'Unskip Phase' : 'Skip Phase',
                            click: function () { vm.togglePhaseSkip(); }
                        }
                    ];
                    break;
                case ('workflow.internalfiles'):
                    vm.workflowTitleMode = 'readonly';
                    // vm.showProgress = false;
                    vm.editTitleData.Title = vm.workflowData.InternalContent.Title;
                    vm.titleContext = 'internalfiles';
                    vm.saveLocalTitle = function () {
                        // noop
                    }
                    vm.siblingNames = [];
                    vm.workflowViewMode = 'internalFiles';
                    break;
            }

            updateProgressBar(true);
            $rootScope.$emit('updateWorkflowTitleBar');
        });

        vm.togglePhaseSkip = function () {
            vm.workflowData.Phases[vm.phaseIndex -1].Status = vm.workflowData.Phases[vm.phaseIndex -1].Status === 'Skipped'
                ? 'Pending'
                : 'Skipped';

            workflowStateService.update(vm.workflowData);

            vm.titleBarButtons[1].text = vm.workflowData.Phases[vm.phaseIndex -1].Status === 'Skipped' ? 'Unskip Phase' : 'Skip Phase';

            // vm.showProgress = vm.workflowData.Phases[vm.phaseIndex -1].Status !== 'Skipped';

            if (vm.showProgress) {
                updateProgressBar(true);
            }

            vm.phaseIndexToAdvanceTo = null;
            if (vm.workflowData.Phases[vm.phaseIndex -1].Status === 'Skipped')
            {
                if (vm.workflowData.Phases.length > vm.phaseIndex) {
                    for (var i = vm.phaseIndex; i < vm.workflowData.Phases.length; i++) {
                        if (vm.workflowData.Phases[i].Access.View && vm.workflowData.Phases[i].Status !== 'Skipped') {
                            vm.phaseIndexToAdvanceTo = i;
                            break;
                        }
                    }
                }

                var message = vm.phaseIndexToAdvanceTo
                    ? 'You have unmarked this phase as skipped and are being taken to the next phase.'
                    : 'You have unmarked this phase as skipped and are being taken back to the roadmap.';
                notifyService.notify(message);

                $timeout(function () {
                    if (!vm.phaseIndexToAdvanceTo) {
                        $state.go('workflow.roadmap', { workflowId: vm.workflowData.Id.split('/')[1] });
                    } else {
                        $state.go('workflow.navigator.phase', { workflowId: vm.workflowData.Id.split('/')[1], phaseIndex: vm.phaseIndexToAdvanceTo + 1 });
                    }
                }, 2000);
            } else {
                notifyService.notify('You have unmarked this phase as skipped');
            }
            
        }

        function updateProgressBar(startAtZero) {
            $timeout(function () {
                if (startAtZero) {
                    $pbService.set('titleBarProgressCircle',0);
                }
                $pbService.animate('titleBarProgressCircle', vm.progressPercentageComplete);
                // $pbService.set('titleBarProgressCircle', vm.progressPercentageComplete);
            });
        }

        vm.editWorkflowTitle = function () {
            vm.workflowTitleMode = 'edit';
            vm.editTitleData.OriginalTitle = vm.editTitleData.Title;
        }

        vm.saveWorkflowTitle = function () {
            if (vm.editTitleData.OriginalTitle !== vm.editTitleData.Title) {
                vm.saveLocalTitle();
                workflowStateService.update(vm.workflowData);
                notifyService.notify(
                    'The ' + vm.titleContext + ' title has been updated');
            }
            vm.editTitleData.OriginalTitle = vm.editTitleData.Title;
            vm.workflowTitleMode = 'display';
        }

        vm.cancelSaveWorkflowTitle = function () {
            vm.workflowTitleMode = 'display';
            vm.editTitleData.Title = vm.editTitleData.OriginalTitle;
        }

        vm.toggleWorkflowReorderMode = function () {
            if (!$rootScope.workflowReorderMode) {
                $rootScope.workflowReorderModeToast = toastr.info('You are currently reordering the workflow phases',
                    {
                        timeOut: 0,
                        extendedTimeOut: 0,
                        closeButton: true,
                        closeHtml: "<button>Stop reordering</button>",
                        onHidden: function () {
                            $rootScope.workflowReorderMode = false;
                        }
                    });
            } else {
                if ($rootScope.workflowReorderModeToast) {
                    toastr.clear($rootScope.workflowReorderModeToast);
                    delete $rootScope.workflowReorderModeToast;
                }
            }

            $rootScope.workflowReorderMode = !$rootScope.workflowReorderMode;
        }

        $scope.$on('workflowUpdated', function () {
            vm.workflowData = workflowStateService.get();
            var newProgressPercentageComplete = 0;
            switch (vm.currentStateName) {
                case 'workflow.roadmap':
                    newProgressPercentageComplete = vm.workflowData.PercentageComplete / 100;
                    break;
                case 'workflow.navigator.phase':
                    newProgressPercentageComplete = vm.workflowData.Phases[vm.phaseIndex - 1].PercentageComplete / 100;
                    break;
            }

            if (newProgressPercentageComplete !== vm.progressPercentageComplete) {
                vm.progressPercentageComplete = newProgressPercentageComplete;
                updateProgressBar();
            }
        });

        $scope.$on('fileUploaded', function (event, args) {
            if (args.parent.isRequiredDownloadCollection) {
                return;
            } else {
                var workflowObject = workflowStateService.getObjectFromPath(vm.workflowData, args.parent.Path);

                if (!workflowObject.BlobSummaries) {
                    workflowObject.BlobSummaries = [];
                }

                workflowObject.BlobSummaries = workflowObject.BlobSummaries.concat(args.blobs);

                mailRequestDataService.sendWorkflowUpdate({
                    EntityId: vm.sessionData.EntityId,
                    WorkflowId: vm.workflowId,
                    Path: args.parent.Path,
                    Context: 'InformationPart',
                    RecordedActivity:
                    {
                        // TODO: Use fields other than description or add this
                        // to the actual workflow activities
                        Description: 'Document' +
                            (args.blobs.length > 1 ? 's' : '') +
                            ' ' +
                            args.blobs.map(function (b) { return b.FileName; }).join(', ')
                            + ' ' +
                            (args.blobs.length > 1 ? 'wer' : 'was') +
                            ' uploaded',
                        UserName: vm.sessionData.UserName,
                        Date: (new Date()).toISOString(),
                        UsersToNotify: workflowObject.Partners.filter(function (partner) {
                            return partner.Access.Notes;
                        }).map(function (filteredPartner) { 
                            return filteredPartner.UserName;
                        })
                    }
                });
            }
            workflowStateService.update(vm.workflowData);
            var fileNames = args.blobs.map(function (upload) {
                return upload.FileName;
            }).join(', ');
            notifyService.notify('You uploaded ' + fileNames);
        });

        vm.changeTab = function (tabName) {
            for (var property in vm.tabs) {
                if (vm.tabs.hasOwnProperty(property)) {
                    vm.tabs[property].active = property === tabName || (
                        vm.tabs[property].additionalStates &&
                        vm.tabs[property].additionalStates.indexOf(tabName) !== -1);
                }
            }
        }

        vm.updateName = function () {
            // This trick makes sure the model is updated before we actually send the update
            $timeout(function () {
                workflowStateService.update(vm.workflowData);
            }, 0);
        }

        signalrService.getConnectionInfo(functionsConfigurationData.negotiate.Url + '?code=' +
        functionsConfigurationData.negotiate.Code).then(function (data) {
            var connection = new signalR.HubConnectionBuilder()
            .withUrl('https://buildify.service.signalr.net/client?hub=activity', {
                accessTokenFactory: function () { return data.accessToken; }
            })
            .build();

            connection.on('activity', messageCallback);
            connection.onclose(function () { console.log('disconnected') });
            console.log('connecting...');
            connection.start()
                .then(function () { onConnected(connection); })
                .catch(function (error) { console.error(error.message); });

            function messageCallback(message) {
                console.dir(message, { depth: null });
                var blobReference = Object.keys(message)[0];
                var existingThumbnails = workflowStateService.getThumbnails();
                if (Object.keys(existingThumbnails).every(function (thumbnailBlobReference) {
                    return thumbnailBlobReference !== blobReference;
                })) {
                    // add the thumbnail
                    existingThumbnails[blobReference] = message[blobReference].BlobReferences;
                    workflowStateService.setThumbnails(existingThumbnails);
                }
            }

            function onConnected(connection) {
                console.log('connection started');
            }
        })
    }

    workflowController.$inject = ['$scope', '$rootScope', '$timeout', '$state', '$uibModal',
        'notifyService', 'workflowData', 'functionsConfigurationData', 'sessionData',
        'workflowStateService', 'mailRequestDataService', 'signalrService', 'toastr', '$pbService'
    ];

    angular.module('ecap.workflow').controller('workflowController', workflowController);
})();